module.exports = __webpack_public_path__ + "img/up-arrow.0a6cdf31.svg";